import consumablesEdit from './edit.vue'
import consumablesList from './list.vue'
import consumablesListAdmin from './listAdmin.vue'
import * as consumablesClass from './consumablesClass'
import * as consumablesCheck from './check.vue'
import * as consumablesClaim from './claim.vue'
import * as consumablesStock from './stock.vue'
import consumablesPurchase from './purchase.vue'
import consumablesPurchaseAdmin from './purchaseAdmin.vue'
import PurchaseOrderAdmin from './PurchaseOrderAdmin.vue'
import ProcessSettings from './ProcessSettings.vue'
import ProcureInfo from './procureInfo.vue'
import Maintenance from './Maintenance.vue'
import monitoringData from './monitoringData.vue'
import * as record from './record'
let a = Object.assign({ consumablesEdit, consumablesPurchase, consumablesPurchaseAdmin, PurchaseOrderAdmin, consumablesList, consumablesListAdmin, ProcessSettings, ProcureInfo, Maintenance, monitoringData }, consumablesClass, consumablesCheck, record, consumablesClaim, consumablesStock)
export default a
